import React from 'react'
import { Column } from '@sencha/ext-modern'

import { handleItemContextMenu } from '../contextmenu'
import { getBindedProps } from './utilities'

const render = ({ _menubuttons, key, title, width, bind, icon, ui = 'action', disabled, hidden, text, /* handler,  */...rest }, that, forViewModel, checkGridData) => {
	const bindedProps = getBindedProps({ bind, icon, ui, disabled, hidden, text }, that, key, forViewModel);

	return (<Column width={width} align="center" key={key} text={title} {...rest}
		cell={{
			tools: [
				{
					type: 'menu', ...bindedProps,
					handler: (tree, { grid, record, event }) => {
						handleItemContextMenu(_menubuttons, grid, record, event, that, checkGridData)
					}
				}
			]
		}}
		menuDisabled
	/>)
}

export default render